import React from 'react'
import { string, bool, number, func } from 'prop-types'
import citygateTheme from '../../theme/'
import IconOffer from '../../vectors/IconOffer'
import IconPrice from '../../vectors/IconPrice'
import IconAccountProfile from '../../vectors/IconAccountProfile'
import IconTickThin from '../../vectors/IconTickThin'
import { Bar, Content, Icons, RightCentreIconClose } from './components'
import SwipeableViews from 'react-swipeable-views'
import { virtualize, autoPlay } from 'react-swipeable-views-utils'
import { mod } from 'react-swipeable-views-core'
import { Link } from 'gatsby'
import styled from 'styled-components'

const AutoPlaySwipeableViews = autoPlay(virtualize(SwipeableViews))

const StyledLink = styled(Link)`
  text-decoration: none;
  font-weight: normal !important;
  &:hover {
    text-decoration: underline;
    color: #ffffff !important;
  }
`

const ContentItem = (props) => (
  <StyledLink to={props.link}>
    <strong>OFFER AVAILABLE: </strong> {props.text}
  </StyledLink>
)

class ContentBar extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      hidden: props.reveal,
      slides: props.slides
    }
    this.dismiss = this.dismiss.bind(this)
    this.show = this.show.bind(this)
    this.setTimeOutTillDismiss = this.setTimeOutTillDismiss.bind(this)
    this.slideRenderer = this.slideRenderer.bind(this)
  }

  componentDidMount() {
    if (this.props.reveal) {
      setTimeout(() => {
        this.show()
      }, 700)
    }
    if (this.props.autodismiss) {
      this.setTimeOutTillDismiss()
    }
  }

  dismiss() {
    this.props.onDismiss()
    this.setState({ hidden: true })
  }

  show() {
    this.setState({ hidden: false })
  }

  setTimeOutTillDismiss() {
    setTimeout(() => {
      this.dismiss()
    }, this.props.timeoutinterval)
  }

  slideRenderer(params) {
    const { index, key } = params
    const loopingIndex = mod(index, this.state.slides.length)
    return <ContentItem key={key} {...this.state.slides[loopingIndex]} />
  }

  render() {
    return (
      <Bar
        py={'18px'}
        px={'3%'}
        bg={this.props.bg}
        fg={this.props.fg}
        error={this.props.error}
        offer={this.props.offer}
        finance={this.props.finance}
        feedback={this.props.feedback}
        warning={this.props.warning}
        success={this.props.success}
        width={'100%'}
        rounded={this.props.rounded}
        overlay={this.props.overlay}
        sticky={this.props.sticky}
        fixed={this.props.fixed}
        hidden={this.state.hidden}
      >
        {(this.props.offer ||
          this.props.finance ||
          this.props.profile ||
          this.props.feedback ||
          this.props.success) && (
          <Icons mr={20} fg={this.props.fg}>
            {this.props.offer && <IconOffer />}
            {this.props.finance && <IconPrice />}
            {this.props.profile && <IconAccountProfile />}
            {(this.props.feedback || this.props.success) && <IconTickThin />}
          </Icons>
        )}
        <Content flex="1 1 auto" px={[50]}>
          {this.props.slides && this.props.slides.length > 1 && (
            <AutoPlaySwipeableViews
              interval={5000}
              slideRenderer={this.slideRenderer}
            />
          )}
          {this.props.slides && this.props.slides.length === 1 && (
            <ContentItem {...this.state.slides[0]} />
          )}
          {this.props.children}
        </Content>

        {this.props.dismissible && (
          <RightCentreIconClose onClick={(evt) => this.dismiss(evt, this)} />
        )}
      </Bar>
    )
  }
}

ContentBar.defaultProps = {
  bg: 'blue',
  fg: citygateTheme.colors.white,
  timeoutinterval: 3000,
  onDismiss: () => {}
}
ContentBar.propTypes = {
  bg: string,
  fg: string,
  offer: bool,
  finance: bool,
  profile: bool,
  feedback: bool,
  warning: bool,
  error: bool,
  dismissible: bool,
  overlay: bool,
  sticky: bool,
  reveal: bool,
  autodismiss: bool,
  timeoutinterval: number,
  onDismiss: func
}

export default ContentBar
